import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled, { css } from 'styled-components';
import {
  minBreakpointQuery,
  maxBreakpointQuery,
  standardColours,
  brandColours,
} from '../styles';
import { Link, Svg } from './ui';
import logo from '../images/logo.svg';
import flowerEyeIcon from '../images/flower-eye-icon.svg';
import santaHat from '../images/site-themes/christmas/santa-hat.svg';

const StyledLogo = styled(Link)`
  display: inline-block;

  ${({ theme }) => {
    if (theme === 'christmas') {
      return css`
        position: relative;
      `;
    }
  }}
`;

const StyledLogoSvg = styled(Svg)`
  display: block;
  height: 25px;
  width: 150px;
  fill: ${brandColours.primary};

  ${minBreakpointQuery.tsmall`
    height: 30px;
    width: 180px;
  `}

  ${({ alt, altTheme }) => {
    if (alt || altTheme) {
      return css`
        fill: ${standardColours.white};
      `;
    }
  }}
  
  ${({ alt, isNavActive }) => {
    if (alt && isNavActive) {
      return css`
        ${maxBreakpointQuery.mlarge`
          fill: ${brandColours.primary};
        `}
      `;
    }
  }}

  ${({ isCheckoutHeader }) => {
    if (isCheckoutHeader) {
      return css`
        ${maxBreakpointQuery.mlarge`
          display: none;
        `}
      `;
    } else {
      return css`
        ${minBreakpointQuery.mlarge`
          height: 24px;
          width: 140px;
        `}

        ${minBreakpointQuery.large`
          height: 27px;
          width: 160px;
        `}

        ${minBreakpointQuery.xlarge`
          height: 30px;
          width: 180px;
        `}
      `;
    }
  }}
`;

const StyledIconSvg = styled(Svg)`
  display: none;

  ${({ isCheckoutHeader }) => {
    if (isCheckoutHeader) {
      return css`
        ${maxBreakpointQuery.mlarge`
          display: block;
          height: 27px;
          width: 44px;
          fill: ${brandColours.primary};
        `}
      `;
    }
  }}
`;

const StyledSantaHatSvg = styled(Svg)`
  position: absolute;
  top: -8px;
  left: 22%;
  height: 16px;
  width: 18px;

  ${minBreakpointQuery.tsmall`
    height: 19px;
    width: 22px;
  `}

  ${minBreakpointQuery.mlarge`
    height: 16px;
    width: 18px;
  `}

  ${minBreakpointQuery.large`
    height: 19px;
    width: 22px;
  `}

  ${({ isCheckoutHeader }) => {
    if (isCheckoutHeader) {
      return css`
        ${maxBreakpointQuery.mlarge`
          display: none;
        `}
      `;
    }
  }}
`;

const Logo = ({ alt, altTheme, isNavActive, isCheckoutHeader, ...props }) => {
  const {
    spaseekers: {
      promotion: { theme },
    },
  } = useStaticQuery(graphql`
    query LogoQuery {
      spaseekers {
        promotion {
          theme
        }
      }
    }
  `);

  return (
    <StyledLogo to="/" theme={theme} {...props}>
      <StyledLogoSvg
        image={logo}
        alt={alt}
        altTheme={altTheme}
        isNavActive={isNavActive}
        isCheckoutHeader={isCheckoutHeader}
      />
      <StyledIconSvg
        image={flowerEyeIcon}
        isCheckoutHeader={isCheckoutHeader}
      />
      {theme === 'christmas' && <StyledSantaHatSvg image={santaHat} />}
    </StyledLogo>
  );
};

export default Logo;
